<template>
  <div>
    <v-simple-table fixed-header fixed-footer height="350px" class="elevation-0">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Product Name</th>
            <th class="text-left">Serial Number</th>
            <th class="text-left">Price</th>
            <th class="text-left">Discount</th>
            <th class="text-left">Discounted price</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id" style="cursor: pointer">
            <td class="text-left">{{ item.product.name }}</td>
            <td class="text-left">{{ item.serial }}</td>
            <td class="text-left">
              {{
                item.sale_id == null
                  ? parseFloat(item.product.price).toLocaleString()
                  : parseFloat(item.amount).toLocaleString()
              }}
            </td>
            <td class="text-left">
              <v-text-field
                v-model="discounts[item.id]"
                hide-details
                dense
                single-line
                solo
              ></v-text-field>
            </td>
            <td class="text-left">
              {{
                item.sale_id == null
                  ? parseFloat(item.product.price - (discounts[item.id] || 0)).toLocaleString()
                  : parseFloat(item.amount - (discounts[item.id] || 0)).toLocaleString()
              }}
            </td>
          </tr>
          <tr v-if="items.length == 0">
            <td colspan="5" style="height:300px;text-align: center">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-card class="elevation-0" v-if="!set.sale_id">
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined color="green" @click="saveDiscounts">
          Save discounts
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form v-on:submit.prevent width="100%" ref="createForm">
          <v-text-field
            v-model="inventorySerial"
            label="Serial Number"
            append-outer-icon="mdi-plus"
            @click:append-outer="attachItem"
            v-on:keyup.enter="attachItem"
            :error-messages="inputErrorMessages('id')"
          />
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: ['items', 'set'],
  data: function() {
    return {
      inventorySerial: '',
      errorMessages: {},
      discounts: {}
    };
  },
  watch: {
    items: function(items) {
      items.forEach(item => {
        this.$set(this.discounts, item.id, item.discount || 0);
      });
    }
  },
  mounted() {
    this.items.forEach(item => {
      this.$set(this.discounts, item.id, item.discount || 0);
    });
  },
  methods: {
    ...mapActions(['Set/getSet']),
    inputErrorMessages(input) {
      return [...(this.errorMessages['id'] || []), ...(this.errorMessages['set_id'] || [])];
    },
    saveDiscounts() {
      this.items.forEach(item => {
        axios
          .put(`api/v1/set/${this.$route.params.id}/item/${item.id}`, {
            discount: this.discounts[item.id]
          })
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Discount updated...',
              color: 'success'
            });
            this.errorMessages = [];
            this['Set/getSet']({ id: this.$route.params.id });
          })
          .catch(response => {
            this.errorMessages = response.response.data.errors;
          })
          .finally(() => {});
      });
    },
    attachItem() {
      axios
        .post(`api/v1/set/${this.$route.params.id}/item`, { id: this.inventorySerial })
        .then(response => {
          this.$store.commit('SET_SNACK_BAR', {
            message: 'Item attached...',
            color: 'success'
          });
          this.errorMessages = [];
          this.inventorySerial = '';
          this['Set/getSet']({ id: this.$route.params.id });
        })
        .catch(response => {
          this.errorMessages = response.response.data.errors;
        })
        .finally(() => {
          this.inventorySerial = '';
          this.loading = false;
        });
      this.inventorySerial = '';
    }
  }
};
</script>
